import { Subscription } from 'rxjs/internal/Subscription';
import { IdleInterruptArgs } from './interrupt-args';
import { IdleInterruptOptions } from './interrupt-options';
import { IdleInterruptSource } from './interrupt-source';

/**
 * A class for managing an interrupt from an interrupt source.
 */
export class IdleInterrupt {
    private sub?: Subscription;

    constructor(public source: IdleInterruptSource, options?: IdleInterruptOptions) {
        if (source.initialize) {
            source.initialize(options);
        }
    }

    /**
     * Subscribes to the interrupt using the specified function.
     * @param fn - The subscription function.
     */
    subscribe(fn: (args: IdleInterruptArgs) => void): void {
        this.sub = this.source.onInterrupt.subscribe(fn);
    }

    /**
     * Unsubscribes the interrupt.
     */
    unsubscribe(): void {
        this.sub?.unsubscribe();
        this.sub = undefined;
    }

    /**
     * Keeps the subscription but resumes interrupt events.
     */
    resume(): void {
        this.source.attach();
    }

    /**
     * Keeps the subscription but pauses interrupt events.
     */
    pause(): void {
        this.source.detach();
    }
}
